<template>
    <div>
        <b-card v-if="!$route.path.includes('import')" no-body>
            <b-tabs
              justified
              v-model="tabIndex"
              nav-class="nav-tabs-inverse"
              nav-wrapper-class="nav-tabs-inverse">
                <!-- begin tab -->
                <b-tab @click="navigateTo('space')">
                    <template slot="title">
                        <span class="d-sm-none">Space</span>
                        <span class="d-sm-block d-none">Space</span>
                    </template>
                </b-tab>
                <!-- end tab -->
                <!-- begin tab -->
                <b-tab @click="navigateTo('stuff')">
                    <template slot="title">
                        <span class="d-sm-none">Stuff</span>
                        <span class="d-sm-block d-none">Stuff</span>
                    </template>
                </b-tab>
                <!-- end tab -->
                <!-- begin tab -->
                <b-tab @click="navigateTo('staff')">
                    <template slot="title">
                        <span class="d-sm-none">Staff</span>
                        <span class="d-sm-block d-none">Staff</span>
                    </template>
                </b-tab>
                <!-- end tab -->
                <!-- begin tab -->
                <b-tab @click="navigateTo('service')">
                    <template slot="title">
                        <span class="d-sm-none">Service</span>
                        <span class="d-sm-block d-none">Service</span>
                    </template>
                </b-tab>
                <!-- end tab -->
                <!-- begin nav-tabs-pills -->
                <div class="row p-20 p-b-0">
                    <div class="col-6">
                        <b-form-radio-group @change="onSwitch" v-model="pathValue" buttons button-variant="outline-secondary">
                            <b-form-radio value="items">Items</b-form-radio>
                            <b-form-radio value="categories">{{ text }}</b-form-radio>
                        </b-form-radio-group>
                    </div>
                    <div class="col-6">
                        <url-button label="Create new" :url="$route.path + '/new'" class="btn-yellow pull-right" />
                    </div>
                </div>
                <!-- end nav-tabs-pills -->
                <router-view class="p-20" v-bind:typeId="typeId" v-bind:items="items" v-bind:categories="categories" v-bind:scriptItems="scriptItems" v-bind:activeEvent="activeEvent" />
            </b-tabs>
        </b-card>
        <div v-else>
            <router-view v-bind:typeId="typeId" v-bind:categories="categories" v-bind:activeEvent="activeEvent" />
        </div>
    </div>
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'

export default {
    name: 'Tabs',
    props: ['typeId', 'items', 'categories', 'scriptItems', 'activeEvent'],
    components: {
        UrlButton
    },
    data() {
        return {
            tabIndex: 0,
            text: 'd',
            pathValue: 'items'
        }
    },
    mounted() {
        this.updateContent();
        if (this.$route.path.includes('items')) {
            this.pathValue = "items";
        } else {
            this.pathValue = "categories";
        }
    },
    methods: {
        navigateTo(typeParam) {
            if (this.$route.params.type != typeParam) {
                this.$router.push({params: {type: typeParam}});
            }
        },
        updateContent() {
            switch (this.typeId) {
                case 1:
                    this.text = "Categories/Areas";
                    this.tabIndex = 3;
                    break;
                case 2:
                    this.text = "Venues/Areas";
                    this.tabIndex = 0;
                    break;
                case 3:
                    this.text = "Groups/Teams";
                    this.tabIndex = 2;
                    break;
                case 4:
                    this.text = "Main categories/Subcategories";
                    this.tabIndex = 1;
                    break;
                default:
                    break;
            }
        },
        onSwitch(value) {
            this.$router.push(value);
        }
    },
    watch: {
        typeId: {
          immediate: true,
          handler () {
            this.$nextTick(() => {
              this.updateContent();
            });
          }
        },
        $route () {
            this.updateContent();
        }
    }
}
</script>
